import { Box, Grid } from '@mui/material';
import { SxClassProps } from '@/types/common';
import { seoSegmentationListingPage_seoSegmentationDetails_SEOSegmentationDetailsSuccess_segmentationDetails as SEOSegmentationDetailsType } from '@/__generated__/seoSegmentationListingPage';
import { usePageAttributes } from '@/components/contexts/PageAttributesContext';
import createRelativeImageURL from '@/utils/createRelativeImageURL';
import { HeroContentCard } from './HeroContentCard';
import { useResponsive } from '../../hooks/useResponsive';
import { HeroContentProvider } from './HeroContentContext';
import { getHeroImages } from '../helpers/getHeroImages';
import { getHeroImageStyles } from '../helpers/getHeroImageStyles';

const getClasses = (heroImageStyles: SxClassProps): SxClassProps => ({
  imageContainer: {
    width: '100%',
    height: {
      xs: '150px',
      sm: '480px',
      md: '565px',
    },
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    borderRadius: {
      xs: '0 0 64px 64px',
      sm: '0 0 120px 120px',
    },
    overflow: 'hidden',
    marginBottom: 3,
    ...heroImageStyles,
  },
});

export type HeroProps = {
  headline: SEOSegmentationDetailsType['headline'];
  subHeadline: SEOSegmentationDetailsType['subHeadline'];
  enrollmentURL: string;
  userGeoInfo: string;
  directoryFirstExperience?: boolean;
  isJobSegment?: boolean;
};

const Hero = ({
  headline,
  subHeadline,
  enrollmentURL,
  userGeoInfo,
  directoryFirstExperience = false,
  isJobSegment = false,
}: HeroProps) => {
  const { isSmallViewport } = useResponsive();
  const { serviceIdForMember, seoSegmentId } = usePageAttributes();
  const { heroImageMobileURL, heroImageTabletURL, heroImageDesktopURL } = getHeroImages(
    seoSegmentId,
    serviceIdForMember
  );
  const heroImageStyles = getHeroImageStyles(seoSegmentId, serviceIdForMember);
  const backgroundImage = {
    backgroundImage: {
      xs: `url(${createRelativeImageURL(heroImageMobileURL)})`,
      sm: `url(${createRelativeImageURL(heroImageTabletURL)})`,
      md: `url(${createRelativeImageURL(heroImageDesktopURL)})`,
    },
  };
  const classes = getClasses({
    ...backgroundImage,
    ...heroImageStyles,
  });

  return (
    <HeroContentProvider
      headline={headline}
      subHeadline={subHeadline}
      enrollmentURL={enrollmentURL}
      directoryFirstExperience={directoryFirstExperience}
      userGeoInfo={userGeoInfo}
      isJobSegment={isJobSegment}>
      <Grid item xs={12} height="100%">
        <Box sx={classes.imageContainer}>{!isSmallViewport && <HeroContentCard />}</Box>
        {isSmallViewport && <HeroContentCard />}
      </Grid>
    </HeroContentProvider>
  );
};

export { Hero };
